import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight, faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
// import { toast } from 'react-toastify';
import { apiService } from '../../../../services/apiService';
import {loadStripe} from '@stripe/stripe-js';
import { toast } from 'react-toastify';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import TaskKnowledge from '../I94Validation/TaskKnowledge';
import CaseDetails from '../CaseDetails/CaseDetails';
import OnboardingOnlyCaseDiscussTab from '../I94Validation/OnboardingOnlyCaseDiscussTab';
function AdmissionFeesPayment() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const onboardslug = parts_location[2] || null;
    const userid = parts_location[3] || null;
    const taskData = parts_location[4] || null;
        const Role_user = localStorage.getItem('role');
        const navigate = useNavigate();
        const [expanded, setExpanded] = useState(true);
        const [loading, setLoading] = useState(true);
        const [status, setStatus] = useState("");
        const [jobseekerName, setJobseekername] = useState("");
        const [caseids, setcaseid] = useState("");
        
        const [stripeKeySet, setStripeKey] = useState();
        const [stripePromise, setStripePromise] = useState(null);
        const [activeTab, setActiveTab] = useState("overview");
        const [activeTabCase, setActiveTabCase] = useState("task");
        const [showCase, setShowCase] = useState(false);
        const [CaseAlldetail, setCaseAllDetail] = useState([]);
        const [showCurrcase, setCaseIdscurrent] = useState('');
        useEffect(() => {
            if(taskData){
                const fetchData = async () => {
                    try {
                        const response = await apiService.getRequest(`task/details/${taskData}`);
                        if (response.success && response.success === true) {
                            setCaseIdscurrent(response.data.case_og_id);
                        }
                    } catch (error) {
                        console.error("Error fetching onboarding data:", error);
                    } finally {
                        setLoading(false);
                    }
                };

                fetchData();
            }
        }, [taskData, navigate]);
        const fetchData = useCallback(async () => {
            if(onboardslug && userid && showCurrcase){
                try {
                const response = await apiService.getRequest(`/onboarding/${onboardslug}/${userid}/${showCurrcase}`);
                if (response.success && response.success === true) {
                    setCaseAllDetail(response.data.case);
                    setShowCase(response.data.can_see_case);
                    setJobseekername(response.data.jobseeker.name);
                    setcaseid(response?.data);
                    
                    setStatus(response.data.status_string);
                    const refetchedData = response.settings;
                    setFormData({
                        onboarding_admission_fee: refetchedData.onboarding_admission_fee,
                        onboarding_service_charge: refetchedData.onboarding_service_charge,
                        onboarding_tax: refetchedData.onboarding_tax,
                        onboarding_total_string: refetchedData.onboarding_total_string,
                        onboarding_total: refetchedData.onboarding_total,
                    });
                    setStripeKey(refetchedData && refetchedData.STRIPE_KEY)
                    setstripeData({
                        payment_type:  "admission_fees_payment",
                        task_id: taskData,
                        amount: refetchedData.onboarding_total,
                        user_id: userid,
                        success_url: `${window.location.origin}/task/admission-fees-payment/${userid}/${taskData}`,
                        cancel_url: `${window.location.origin}/task/admission-fees-payment/${userid}/${taskData}`
                    });
                    
                }else{
                    if(response.error_code === "E_PERMISSION_DENIED"){
                        toast.error(response.message || "Permission denied!");
                        navigate("/dashboard");
                    }else if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
                } catch (error) {
                console.error("Error fetching onboarding data:", error);
                } finally {
                setLoading(false);
                }
            }
        }, [onboardslug, userid, taskData,showCurrcase, navigate]);
        
        useEffect(() => {
            fetchData();
        }, [fetchData]);

    const [errorsCase, setErrorsCase] = useState({});
    const [errorsCaseMessage, setErrorMessageCase] = useState("");
    const [selectedCaseStatus, setSelectedCaseStatus] = useState("");
    const [showCasepop, setShowCasepop] = useState(false);
    const [loadingCase, setSubmitloaderCase] = useState(false);
    const [caseActionform, setCaseActionForm] = useState({
        status: "",
        justification: "",
    })

    const handleselectCase = (statussend) => {
        setSelectedCaseStatus(statussend);
        setShowCasepop(true);
        setCaseActionForm((prevData) => ({
            ...prevData,
            status: statussend,
        }));
    };
    const handleCloseCase = () => setShowCasepop(false);

    const handleInputCasedata = (e) => {
        const { name, value } = e.target;

        const newValue = name === "to_onboarding_id" ? Number(value) : value;

        setCaseActionForm((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));

        setErrorsCase((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const validateFormCase = () => {
        const newErrors = {};
        if (!caseActionform.justification) newErrors.justification = "Justification is required.";
        if (caseActionform.justification && caseActionform.justification.length < 3) {
            newErrors.justification = "justification must be at least 3 characters long.";
        }else if (caseActionform.justification && caseActionform.justification.length > 4000) {
            newErrors.justification = 'justification must be less than 4000 characters long.';
        }
        setErrorsCase(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCaseStatus = async (e) => {
        e.preventDefault();
        if (!validateFormCase()) {
            setErrorMessageCase('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloaderCase(true);
        try {
            const response = await apiService.postRequest(`/task-cases/${CaseAlldetail.id}/status`, caseActionform);
            
            if (response && response.success === true) {
                fetchData();
                window.location.reload();
                setErrorMessageCase("");
                setShowCasepop(false);
                setCaseActionForm({
                    status: "",
                    justification: "",
                })
            } else {
                if (response.errors) {
                    setErrorsCase(response.errors);
                }
                toast(response.message || "Somthing went wrong!")
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log(error,'Failed. Please try again.');
        } finally {
            setActiveTab("overview");
            setActiveTabCase("task");
            setSubmitloaderCase(false); // Stop loader
        }
    };
    
    const [formData, setFormData] = useState({
        default_currency: '',
        onboarding_admission_fee: '',
        onboarding_service_charge: '',
        onboarding_tax: '',
        onboarding_total: '',
        onboarding_total_string: '',
    });
    const [sripeData, setstripeData] = useState({
        payment_type:  "admission_fees_payment",
        task_id: taskData,
        amount: formData.onboarding_total,
        user_id: userid,
        success_url: `${window.location.origin}/task/admission-fees-payment/${userid}/${taskData}`,
        cancel_url: `${window.location.origin}/task/admission-fees-payment/${userid}/${taskData}`
    });
    const [submitloader,setSubmitloader] = useState(false)

    useEffect(() => {
        if (stripeKeySet) {
            setStripePromise(loadStripe(stripeKeySet));
        }
    }, [stripeKeySet]);
    // const stripePromise = loadStripe(stripeKeySet);
    // console.log("stripe",stripePromise)
    const submitsripe = async (e) => {
        e.preventDefault();
        setSubmitloader(true);
        if (stripeKeySet && stripeKeySet.length > 0 && stripePromise) {
            try {
                const response = await apiService.postRequest(`stripe/create-checkout-session`, sripeData);
        
                // Check response for success
                if (response && response.success && response.id) {
                    const stripe = await stripePromise;
                    if (stripe) {
                        await stripe.redirectToCheckout({ sessionId: response.id });
                    } else {
                        toast.error("Stripe failed to initialize.");
                    }
                } else {
                    toast(response.message || "Failed, Please try again");
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console('Failed. Please try again.');
            } finally {
                setSubmitloader(false); // Stop loader
            }
        }else {
            toast.error("Stripe key not available.");
        }
    };
    
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const fetchDataStri = useCallback(async () => {
        setLoading(true);
        if (sessionId && sessionId.length > 0) {
            const sessionset = { session_id: sessionId };
            try {
                const response = await apiService.postRequest(`/stripe/success`, sessionset);
                if (response.success && response.success === true) {
                    toast("Payment Completed");
                    setStatus("completed");
                }else{
                    toast.error("Payment Failed");
                }
            } catch (error) {
                console.error("Error fetching onboarding data:", error);
            } finally {
                setLoading(false);
            }
        }
    }, [sessionId]);

    useEffect(() => {
        fetchDataStri();
    }, [fetchDataStri]);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container_validate' style={{ flexGrow: 1 }}>
            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
            <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${caseids?.case?.case_link}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.case?.case_formatted_id}
                    </b>
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.task?.task_format_id} - ${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.task?.task_format_id}
                    </b>
                </span>
            </Grid>
            {loading ? 
            <div className='d-flex justify-content-center w-100'>
                <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :
            <Grid size={{sm:12}} container className="main_jobseeker justify-content-between">
                <Grid size={{ lg: !showCase ? 12 : expanded ? 7.6 : 11.5, md: !showCase ? 12 : expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container className={`tab_controllers ${ Role_user && Role_user !== "job_seeker" ? "flex-row-reverse pe-4 align-items-start align-content-start justify-content-between" : "hide_tabseeker"}`} >
                    {Role_user && Role_user !== "job_seeker" ?
                    <Grid container className="gap-3 case_control_btn" justifyContent="flex-end">
                            {showCase && activeTabCase === "case" && <>
                            {CaseAlldetail?.status !== "suspend" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "hold" ?
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("hold")}>Hold</button>:
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("resume")}>Resume</button>
                                }
                            </>}
                            {CaseAlldetail?.status !== "hold" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "suspend" ?
                                <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("suspend")}>Suspend</button>:
                                ""
                                }
                            </>}
                            </>}
                        </Grid>:<div></div>}
                    <Tabs
                        activeKey={activeTabCase}
                        onSelect={(key) => setActiveTabCase(key)}
                        defaultActiveKey="task"
                        id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs tabs_noneseeker"
                    >
                        <Tab eventKey="task" title="Task">
                            <Grid size={{sm:12}} container alignItems="center">
                                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead border_botomer mario_fixers">
                                    <h3>Admission Fees</h3>
                                    <b>{caseids?.jobseeker?.formatted_id} - {jobseekerName}</b>
                                </Grid>
                                {loading ? 
                                    <div className='d-flex justify-content-center w-100'>
                                        <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                    <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                        <Tabs
                                            activeKey={activeTab}
                                            onSelect={(key) => setActiveTab(key)}
                                            defaultActiveKey="overview"
                                            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                            >
                                            <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                            {status && status !== "completed" ? <>
                                                <Grid size={{xs:12}} container className="mt-5">
                                                    <span><img src={require("../../../../assets/admissionfee.svg").default} alt='Fee'/> This fee covers application processing, registration materials.</span>
                                                </Grid>
                                                <Grid size={{xs:12}} container className="mt-5 admission_shows">
                                                    <span>Admission Fee <b>{formData.onboarding_admission_fee}</b></span>
                                                    <span>Service Charge <b>{formData.onboarding_service_charge}</b></span>
                                                    <span>Tax <b>{formData.onboarding_tax}</b></span>
                                                    <span className='totalspan_admissionshow'>Total <b>{formData.onboarding_total_string}</b></span>
                                                </Grid>
                                                {Role_user && Role_user === "job_seeker" ?
                                                <Grid size={{xs:12}} container justifyContent="flex-end">
                                                    <button className='registersendbtn2 px-4' style={{width:"max-content"}} onClick={submitsripe}>{submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Pay Admission Fees'}</button>
                                                </Grid> : ""}
                                                </> : <>
                                                <Grid size={{xs:12}} container justifyContent="center" className="fessthanks my-5">
                                                    <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                                                    <h3>Thank you for your payment!</h3>
                                                    <small>Your receipt has been emailed to you.</small>
                                                    <Grid size={{md:10,xs:12}} container justifyContent="space-evenly" className="thaks_topline">
                                                        <span>Amount Paid:<b>{formData.onboarding_total_string}</b></span>
                                                        <span>Paid by:<b>Stripe</b></span>
                                                    </Grid>
                                                </Grid>
                                                </>}
                                            </Tab>
                                            <Tab eventKey="knowledge" title="Knowledge">
                                                {activeTab === "knowledge" && <TaskKnowledge />}
                                            </Tab>
                                        </Tabs>
                                    </Grid>
                                </>}
                                
                                {/* <Grid size={{xs:12}} container justifyContent="center" className="fessthanks">
                                    <FontAwesomeIcon className='main_crossred' icon={faCircleXmark} />
                                    <h3>Transaction Failed!</h3>
                                    <small>Please try again!</small>
                                </Grid> */}
                            </Grid>
                        </Tab>
                        {showCase &&
                        <Tab eventKey="case" title="Case">
                            {activeTabCase === "case" && <CaseDetails expanded={expanded}/>}
                        </Tab>}
                    </Tabs>
                </Grid>
                {showCase &&
                <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 5 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                    <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                        {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                    </button>
                    <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                        <OnboardingOnlyCaseDiscussTab showCase={showCase} />
                    </Grid>
                </Grid>}
            </Grid>}
            <Modal
                show={showCasepop} 
                onHide={handleCloseCase}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    {selectedCaseStatus === "suspend" && <small className='fw-bold'>Suspending this case will also suspend the job seeker and block future login.</small>}
                    <p>Are you sure you want to change the status to{" "}<strong className='uppercasers'>{selectedCaseStatus}</strong>?</p>
                    <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div>
                    {errorsCaseMessage && <p style={{color:"Red",width:"100%",textAlign:"left"}}>{errorsCaseMessage}</p>}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={handleCaseStatus}>
                    {loadingCase ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default AdmissionFeesPayment
